// application side effects are operations/behavious that occurs after the app has been rendered
import { useIdentifyUserForLaunchDarkly } from '@/hooks/flags/useIdentifyUserForLaunchDarkly';
import { useWaitingRoomNotifications } from '@/hooks/useWaitingRoomNotifications/useWaitingRoomNotifications';
import { CreatePrescriptionTutorialModal } from './PatientPageV2/components/CreatePrescriptionTutorialModal/CreatePrescriptionTutorialModal';
import { useShowInventoryInsightsTutorial } from './PatientPageV2/hooks/useShowInventoryInsightsTutorial';

export const AppSideEffects = function () {
  const { openTutorialModal, handleWatchLaterAndDismissModal, handleWatchNow } = useShowInventoryInsightsTutorial();
  // hook for identifying user for LaunchDarkly
  useIdentifyUserForLaunchDarkly();
  // hook for polling waiting rooms and displaying notification
  useWaitingRoomNotifications();

  return (
    <CreatePrescriptionTutorialModal
      open={openTutorialModal}
      handleClose={handleWatchLaterAndDismissModal}
      handleClickPrimaryButton={handleWatchNow}
      handleClickSecondaryButton={handleWatchLaterAndDismissModal}
    />
  );
};
